import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

const Loading = ({ prompt = 'Loading...' }) => (
  <div style={{ minHeight: 200, position: 'relative' }}>
    <Dimmer active inverted>
      <Loader inverted>{prompt}</Loader>
    </Dimmer>
  </div>
);

export default Loading;
